/**
 * lead-mql — Lead Intelligence Report (Marketing Qualified).
 *
 * Full template with its own conf: the MQL document is the SQL renderer run
 * WITHOUT the activity-timeline and interaction-summary sheets (the same
 * payload schema, fewer sheets — identical validation and translation keys).
 * Sharing the SQL renderer is ordinary code reuse, nothing "derived".
 */
import { SQL_REVISION, validateSqlReport, translationTexts, validateTranslations, type SqlReport, type Translations } from '../../schema/lead';
import { renderSqlReport } from '../lead-sql/render';

export const conf = {
  id: 'lead-mql',
  name: 'Lead MQL',
  description: 'Identity, briefing and strategic fit for the next conversation.',
  /** Shares the SQL payload contract, so it shares the SQL revision. */
  revision: SQL_REVISION,
  sourceKinds: ['lead'] as const,
  pdfBucket: 'lead-reports' as const,
  sectionConfig: true,
  i18n: 'ai' as const,
};

export const reportTemplate = {
  conf,
  validate: validateSqlReport,
  translationTexts: (d: SqlReport): Translations => translationTexts(d),
  validateTranslations: (d: SqlReport, t: unknown) => validateTranslations(d, t),
  render: (d: SqlReport, o: Parameters<typeof renderSqlReport>[1] = {}) => renderSqlReport(d, { ...o, mql: true }),
};
